import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {ItemKey} from "../item/core/ItemKey";
import {Currency} from "@/modules/redactor/models/currency/Currency";
import {TriggerUtils} from "@/modules/redactor/models/trigger/core/TriggerUtils";

export class WorldRegionTerritory extends BaseObject {

    constructor() {
        super();

        this._regionTerritory = 0;

        this._key = null;

        this._items = [];
        this._money = [];

        this._autoOpen = false;
        
        this._triggers = [];
    }

    get regionTerritory() {
        return this._regionTerritory;
    }

    set regionTerritory(value) {
        this._regionTerritory = value;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    get money() {
        return this._money;
    }

    set money(value) {
        this._money = value;
    }

    get triggers() {
        return this._triggers;
    }

    set triggers(value) {
        this._triggers = value;
    }

    get autoOpen() {
        return this._autoOpen;
    }
    
    set autoOpen(value) {
        this._autoOpen = value;
    }

    valid() {

        if (!Number.isInteger(this.regionTerritory) || this.regionTerritory < 0) {
            return false;
        }

        for (const currency of this.money) {
            if (!currency.valid()) {
                return false;
            }
        }
        
        for (const itemKey of this.items) {
            if (!itemKey.valid()) {
                return false;
            }
        }

        if (this.triggers && this.triggers.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new WorldRegionTerritory());
        } else if (target instanceof WorldRegionTerritory) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(WorldRegionTerritory, {
    _regionTerritory: alias("region_territory", Schema.primitive()),
    _key: alias("key", Schema.primitive()),
    _items: alias("items", list(ItemKey.schema())),
    _money: alias("money", list(Currency.schema())),
    _triggers: alias("triggers", TriggerUtils.schema()),
    _autoOpen: alias("auto_open", Schema.primitive()),
});